import axios from 'axios';
import { spaceClient } from './client';
import { API_BASE } from './apiConfig';

// ── Events ─────────────────────────────────────────────────────────────────
// Reads go through the CMS-only endpoint (drafts/pending included, approval
// metadata attached); writes go through the space-scoped, approval-gated
// endpoint — same read/write split as itemApi.js.
export const getEvents = () =>
  spaceClient.get('/cms/events', { withCredentials: true }).then((r) => r.data);

export const getEventById = (id) =>
  spaceClient.get(`/cms/events/${id}`, { withCredentials: true }).then((r) => r.data);

export const createEvent = (data) =>
  spaceClient.post('/events', data, { withCredentials: true }).then((r) => r.data);

export const updateEvent = (id, data) =>
  spaceClient.put(`/events/${id}`, data, { withCredentials: true }).then((r) => r.data);

export const deleteEvent = (id) =>
  spaceClient.delete(`/events/${id}`, { withCredentials: true });

export const getEventAccess = (id) =>
  spaceClient.get(`/events/${id}/access`, { withCredentials: true }).then((r) => r.data);

// ── Lookup Tables ───────────────────────────────────────────────────────────
// "content-event-types" (not "event-types") — that name is already taken by
// the unrelated Rules Engine trigger-type lookup.
export const getContentEventTypes = () =>
  axios.get(`${API_BASE}/api/lookups/content-event-types`, { withCredentials: true }).then((r) => r.data);

export const getPlatformTypes = () =>
  axios.get(`${API_BASE}/api/lookups/platform-types`, { withCredentials: true }).then((r) => r.data);

export const getEventFormats = () =>
  axios.get(`${API_BASE}/api/lookups/event-formats`, { withCredentials: true }).then((r) => r.data);
